import { Trans, useLingui } from '@lingui/react/macro'
import { Stack, Table } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { AppModal } from '@markku/components'
import { ServiceCard } from './ServiceCard'
import { ServiceTableRow } from './ServiceTableRow'
import { sortByPriority, type ServiceStatusData } from './utils'

export function MaintenanceLogModal({
  opened,
  onClose,
  data,
  companyId,
}: {
  opened: boolean
  onClose: () => void
  data: ServiceStatusData
  companyId: string
}) {
  const { t } = useLingui()
  const isMobile = useMediaQuery('(max-width: 768px)')
  const rows = sortByPriority(data.services)

  return (
    <AppModal
      opened={opened}
      onClose={onClose}
      title={t`Maintenance status`}
      size="xl"
      showFooter={false}
      closeOnClickOutside
      closeOnEscape
    >
      {isMobile ? (
        <Stack gap={0}>
          {rows.map((s) => (
            <ServiceCard key={s.taskId} service={s} companyId={companyId} />
          ))}
        </Stack>
      ) : (
        <Table verticalSpacing="sm" horizontalSpacing="md" highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>
                <Trans>Task</Trans>
              </Table.Th>
              <Table.Th>
                <Trans>Status</Trans>
              </Table.Th>
              <Table.Th>
                <Trans>Last</Trans>
              </Table.Th>
              <Table.Th>
                <Trans>Next</Trans>
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.map((s) => (
              <ServiceTableRow
                key={s.taskId}
                service={s}
                companyId={companyId}
              />
            ))}
          </Table.Tbody>
        </Table>
      )}
    </AppModal>
  )
}
